<div class="catalog-body"
     fxFlex="100"
     fxLayout="column"
     fxFlex.mm-lt-tablet-landscape="100"
     [mmTestState]="(isProductsLoading$ | async) ? 'loading' : 'loaded'">
  <app-search-zero-result-search
    *ngIf="isZeroResult"
    [isMobile]="isMobile"
    [isDesktop]="isDesktop"
    [searchTerm]="searchQuery"
    [recommendedProductsFromSearchResponse]="recommendedProducts"
    [recommendedProductsType]="recommendedProductsType"
    [hasFilters]="hasFilters"
    [isExpired]="isExpired"
    [isCategoryPage]="isCategoryPage">
  </app-search-zero-result-search>

  <app-search-product-list
    *ngIf="products?.length"
    [products]="products"
    [isSearch]="searchQuery != null"
    [isCustomPLPPage]="isCustomPLPPage"
    [queryParams]="queryParams"
    [isMobile]="isMobile"
    [isDesktop]="isDesktop"
    [isTablet]="isTablet"
    [isMobileOrTablet]="isMobileOrTablet"
    [isSearchFromHeaderBar]="isSearchFromHeaderBar$ | async"
    [searchCorrection]="searchCorrection"
    [pageNumberWhenUserSearchedFromHeaderBar]="pageNumberWhenUserSearchedFromHeaderBar$ | async"
    [totalCount]="totalCount"
    [productsAreLoading]="isProductsLoading$ | async"
    (switchOffManualSearch)="switchOffManualSearch()"
    (productVisibilityChange)="onProductVisibility($event)">
  </app-search-product-list>
  <app-vat-disclaimer-plps *ngIf="isVATDisclaimerEnabled && !isZeroResult
  && !((this.isLoggedIn$ | async) && (this.isB2CUser$ | async))" [isDesktop]="isDesktop">
  </app-vat-disclaimer-plps>

  <div *ngIf="totalCount"
       class="catalog-body__actions pagination-nav-centre"
       appIsVisible [keepMeTracked]="true" (isVisible)="onPaginationVisibilityChange($event)">
    <mm-paginator
      [queryParams]="queryParams"
      [totalCount]="totalCount"
      [loadMoreLabel]="'CATALOG.CATALOG_PAGE.PAGINATOR.LOAD_MORE.LABEL' | translate"
      [defaultLimit]="defaultLimit"
      [isBot]="true"
      [showLastPage]="false"
      [hideLoadMoreButton]="true"
      [offsetVector]="defaultLimit"
      (paginationChange)="onPageSelected($event)">
    </mm-paginator>
  </div>

  <app-other-buckets-banner *ngIf="(isCartQuantityZero$ | async) && !isZeroResult"
                            [searchQuery]="searchQuery"
                            [isZeroResult]="isZeroResult">
  </app-other-buckets-banner>

  <app-catalog-recommended-products
    *ngIf="!isZeroResult && (recommendedProducts && recommendedProducts.length)"
    [products]="recommendedProducts | slice: 0:recommendedProductsLimit"
    [type]="recommendedProductsType">
  </app-catalog-recommended-products>
</div>
